/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCreateStorageTransactionRequest, ApiStorageTransaction, LockElement } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of StorageTransactionsController.
 */
export class StorageTransactionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /storage_transactions:prefill
     */
    public createPrefilledStorageTransaction(request: ApiCreateStorageTransactionRequest | undefined): Promise<Result<ApiStorageTransaction>> {
        return this.http.post<Result<ApiStorageTransaction>, ApiCreateStorageTransactionRequest | undefined>('/storage_transactions:prefill', request);
    }

    /**
     * Calls GET /storage_transactions:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiStorageTransaction>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiStorageTransaction>>>('/storage_transactions:query', query);
    }

    /**
     * Calls POST /storage_transactions:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiStorageTransaction>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiStorageTransaction>>, ListRequest>('/storage_transactions:query', listRequest, query);
    }

    /**
     * Calls PUT /storage_transactions/{primaryId}
     */
    public update(dto: ApiStorageTransaction, primaryId: string): Promise<Result<ApiStorageTransaction>> {
        return this.http.put<Result<ApiStorageTransaction>, ApiStorageTransaction>(`/storage_transactions/${primaryId}`, dto);
    }

    /**
     * Calls POST /storage_transactions/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiStorageTransaction>> {
        return this.http.post<Result<ApiStorageTransaction>, undefined>(`/storage_transactions/${draftId}/commit`, undefined);
    }

    /**
     * Calls DELETE /storage_transactions/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/storage_transactions/${primaryId}`);
    }

    /**
     * Calls POST /storage_transactions/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiStorageTransaction[]>> {
        return this.http.post<Result<ApiStorageTransaction[]>, string[]>('/storage_transactions/locks', ids);
    }

    /**
     * Calls POST /storage_transactions/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/storage_transactions/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /storage_transactions/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/storage_transactions/${primaryId}/locks`);
    }

    /**
     * Calls GET /storage_transactions/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiStorageTransaction>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiStorageTransaction>>(`/storage_transactions/${primaryId}`, query);
    }

    /**
     * Calls POST /storagetransactions:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiStorageTransaction>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiStorageTransaction>>, ListRequestWithIds>('/storagetransactions:batch', listRequest, query);
    }
}
